/* eslint-disable @atlaskit/design-system/prefer-primitives */

import React from 'react';
import { Background } from './Background';
import { Header } from './Header';
import { PageActions } from './PageActions';
import { PageContent } from './PageContent';
import { PageHeader } from './PageHeader';
import { Search } from './Search';
import { SecondaryNav } from './SecondaryNav';
import { Sidebar } from './Sidebar';
export var BitbucketLightTheme = function BitbucketLightTheme() {
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "testId-bitbucket-wireframe"
  }, /*#__PURE__*/React.createElement(Background, null), /*#__PURE__*/React.createElement(Header, null), /*#__PURE__*/React.createElement(Search, null), /*#__PURE__*/React.createElement(SecondaryNav, null), /*#__PURE__*/React.createElement(PageHeader, null), /*#__PURE__*/React.createElement(PageActions, null), /*#__PURE__*/React.createElement(PageContent, null), /*#__PURE__*/React.createElement(Sidebar, null));
};